export default __webpack_public_path__ + "static/media/banner-loja-lojista.32cc828a.jpg";